class JSONFilesEnum {
    public static WORKERS_JSON = '/JSON/workers.json';
    public static WORKERS_JSON_JTC = '/JSON/workers-JTC.json';
    public static WORKERS_JSON_PATHWAY = '/JSON/workers-pathway.json';
    public static TRAINING_PROGRAM_CAREER = '/JSON/training-program-career.json';
}

export default JSONFilesEnum
